import { Component, Input, OnInit } from '@angular/core';
import { TimelineSection } from '../../../../_models/timeline-models/section-listing.model';

@Component({
    selector: 'homework-section',
    templateUrl: './homework-section.component.html',
    styleUrls: ['./homework-section.component.css'],
    standalone: false
})
export class HomeworkSectionComponent implements OnInit {

  @Input("timelineSection") timelineSection: TimelineSection;

  constructor(
  ) { }

  ngOnInit() {
  }

}
